import script from "./DetailTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./DetailTable.vue?vue&type=script&lang=ts&setup=true"

import "./DetailTable.vue?vue&type=style&index=0&id=36e18f31&lang=scss"

const __exports__ = script;

export default __exports__